import React from 'react'
import TableSkeleton from '../../skeleton/tableSkeleton'

function CategoriesBody({ search, carModels, removeHandler }) {
  return (
    <table className="w-full text-sm text-right relative whitespace-nowrap">
      <thead className="text-md bg-light-blue dark:bg-slate-800 sticky top-0 w-full">
        <tr className={'border-b border-b-light-gray dark:border-b-gray-700'}>
          <th scope="col" className="px-6 py-4 max-w-[60px] dark:text-amber-100">
            ردیف
          </th>
          <th scope="col" className="px-6 py-4 dark:text-amber-100">
            نام دسته بندی خودرو
          </th>
          <th scope="col" className="px-6 py-4 dark:text-amber-100">
            عملیات
          </th>
        </tr>
      </thead>

      <tbody className={'text-md bg-light-blue dark:bg-slate-800'}>
        {carModels
          .filter(({ model }) => model.toLowerCase().includes(search?.toLowerCase()))
          .map((car, index) => {
            return !car ? (
              <TableSkeleton key={index} index={index} count={3} />
            ) : (
              <tr key={car.id} className="border-b border-b-light-gray dark:border-b-gray-700">
                <td className="px-6 py-4 dark:text-amber-50">{index + 1}</td>
                <td className="px-6 py-4 dark:text-amber-50">{car?.model}</td>
                <td className="px-6 py-4 dark:text-amber-50">
                  <button
                    onClick={() => removeHandler(car.id)}
                    className="font-medium text-rose-500 "
                  >
                    حذف
                  </button>
                </td>
              </tr>
            )
          })}
      </tbody>
    </table>
  )
}

export default CategoriesBody
